import { IntlShape } from "react-intl";

import { SalesDataTimePeriod } from "../data-store";

export function formatTimePeriod(
  timePeriod: SalesDataTimePeriod,
  intl: IntlShape
): string {
  switch (timePeriod.periodType) {
    case "Monthly":
      return intl.formatDate(
        new Date(timePeriod.year, (timePeriod.month || 1) - 1),
        {
          year: "numeric",
          month: "long",
        }
      );
    case "Quarterly":
      return `Q${timePeriod.quarter} ${timePeriod.year}`;
    case "Half Yearly":
      return `H${timePeriod.halfYear} ${timePeriod.year}`;
    case "Yearly":
      return timePeriod.year.toString();
    default:
      return timePeriod.year.toString();
  }
}

export function timePeriodToQueryParams(
  timePeriod: SalesDataTimePeriod | null
): string {
  if (!timePeriod) {
    return "";
  }

  const params = new URLSearchParams();
  params.set("year", timePeriod.year.toString());

  if (timePeriod.month !== undefined) {
    params.set("month", timePeriod.month.toString());
  }
  if (timePeriod.quarter !== undefined) {
    params.set("quarter", timePeriod.quarter.toString());
  }
  if (timePeriod.halfYear !== undefined) {
    params.set("half_year", timePeriod.halfYear.toString());
  }

  return params.toString();
}
